import { render, staticRenderFns } from "./SaldoModalManage.vue?vue&type=template&id=84270ce4&scoped=true"
import script from "./SaldoModalManage.vue?vue&type=script&lang=js"
export * from "./SaldoModalManage.vue?vue&type=script&lang=js"
import style0 from "./SaldoModalManage.vue?vue&type=style&index=0&id=84270ce4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84270ce4",
  null
  
)

export default component.exports